import { __assign } from "tslib";
import React, { useRef } from 'react';
import Torpedo from '../Torpedo';
import { measuredDefaultSize, MeasuredContainer, } from '../../Measured';
import useScreenBounds from '../../utils/hooks/useScreenBounds';
var SCROLL_TIMEOUT = 500;
var VISIBLE_PADDING = 300;
var MIN_RENDERED_PADDING = { desktop: 5000, mobile: 4000 };
function getMeasuredContainer(containerFromProps, measuredContainer) {
    if (!measuredContainer) {
        return __assign({}, containerFromProps);
    }
    return __assign(__assign({}, containerFromProps), { width: Number(measuredContainer.width || (containerFromProps || {}).width), height: Number(measuredContainer.height || (containerFromProps || {}).height) });
}
var MeasuredTorpedo = function (props) {
    var containerRef = useRef(null);
    var windowBounds = useScreenBounds(containerRef, SCROLL_TIMEOUT, VISIBLE_PADDING, true, MIN_RENDERED_PADDING);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(MeasuredContainer, { cookieType: props.cookieType, cookieDim: props.cookieDim, defaultSize: props.defaultSize || measuredDefaultSize, listenOnWindow: props.listenOnWindow || true, limitToParentWidth: true }, function (measuredProps) {
            var torpedoProps = __assign(__assign({}, props), { container: getMeasuredContainer(props.container, measuredProps.container) });
            if (props.enableScrollVisibilityOptimisation) {
                torpedoProps.container.bounds = windowBounds;
            }
            return React.createElement(Torpedo, __assign({ innerRef: measuredProps.onRef }, torpedoProps));
        })));
};
export default MeasuredTorpedo;
//# sourceMappingURL=MeasuredTorpedo.js.map